import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";
import { SUGGESTIONS_STORAGE_KEY } from "../const";

const columnSuggestionsLocalStorageProvider = createModuleStorage(localStorage, SUGGESTIONS_STORAGE_KEY);

export default columnSuggestionsLocalStorageProvider;
